import script from "./EObservationHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./EObservationHistory.vue?vue&type=script&setup=true&lang=ts"

import "./EObservationHistory.vue?vue&type=style&index=0&id=7675ebf6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7675ebf6"]])

export default __exports__